(function() {
    'use strict';

    var TmsDatalayer = require('../models/tms_datalayer.model').default;
    var datalayer = new TmsDatalayer();

    module.exports = {
        fireEvent: function(category, key, value) {
            datalayer.fireEvent(category, key, value);
        },

        updateDatalayer: function() {
            datalayer.updateDatalayer();
        },

        extendDatalayer: (data) => {
            datalayer.extendDatalayer(data);
        },
    };
}());
